import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <div className="text-center mb-12" data-id="element-139">
          <p className="text-xl font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-140">
            Te presentamos el
          </p>
          <h2 className="text-4xl md:text-5xl font-black uppercase text-[#E9830F]" data-id="element-141">
            KIT APRENDIZAJE EN CASA
          </h2>
        </div>

        <div className="border-4 border-blue-100 rounded-3xl p-8 md:p-12 shadow-lg bg-[#FFF7F7]" data-id="element-142">
          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-143">
            Un material práctico basado en herramientas psicopedagógicas que te
            ayudará a:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-144">
            {['comprender cómo aprende tu hijo', 'acompañarlo sin generar frustración', 'estimular su interés por aprender', 'mejorar la concentración y la comprensión', 'transformar el aprendizaje en una experiencia positiva'].map((item, index) => <div key={index} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-blue-50" data-id="element-145">
                <div className="bg-green-100 rounded-full p-1 mr-4 flex-shrink-0 mt-1" data-id="element-146">
                  <Check className="h-6 w-6 text-green-600 stroke-[3]" data-id="element-147" />
                </div>
                <span className="text-lg font-semibold text-gray-800" data-id="element-148">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center mt-10" data-id="element-149">
            <p className="inline-block bg-yellow-200 text-yellow-900 px-6 py-3 rounded-full text-xl font-bold" data-id="element-150">
              Todo explicado de forma simple y pensado especialmente para
              padres.
            </p>
          </div>

          <div className="flex justify-center mt-10" data-id="element-151">
            <CTAButton text="¡QUIERO EL KIT AHORA!" subtext="Acceso inmediato · Descarga digital" data-id="element-152" />
          </div>
        </div>
      </div>
    </section>;
}